<template>
  <div class="chart-databutton-group">
    <template v-if="subgroups">
      <div class="label line">
        <slot></slot>
        <button
          class="button-icon ml-auto"
          type="button"
          @click="$emit('remove')"
        >
          <lucide-icon name="x" />
        </button>
      </div>
      <div
        class="column pl-3"
        style="
          border-left: 2px solid var(--color-grey-light);
          margin-left: 0.25rem;
        "
      >
        <chart-data-button
          v-for="subgroup in subgroups"
          :key="'i' + subgroup"
          :chart-uid="chartUid"
          :item-type="itemType"
          :item-id="itemId"
          :subgroup="subgroup"
          :removable="false"
        >
          {{ $t(`chartSubgroups.${subgroup}`) }}
        </chart-data-button>
      </div>
    </template>

    <chart-data-button
      v-else
      :chart-uid="chartUid"
      :item-type="itemType"
      :item-id="itemId"
      @remove="$emit('remove')"
    >
      <slot :subgroup="undefined"></slot>
    </chart-data-button>
  </div>
</template>

<script setup lang="ts">
import LucideIcon from "@core/ui/LucideIcon.vue";
import ChartDataButton from "./ChartBuilderDataButton.vue";
import type { ConfigurableType } from "@editor/items/charts/ChartItem";
import type { Uid } from "@/helpers/utility/Id";

defineOptions({
  inheritAttrs: false
});

interface Props {
  subgroups?: string[];

  chartUid: Uid<"evaluation" | "chart">;
  itemType: ConfigurableType;
  itemId: number | string;
  removable?: boolean;
}
defineProps<Props>();

defineEmits<{
  (e: "remove"): void;
}>();
</script>

<style lang="scss"></style>
